<app-login-header></app-login-header>
<nes-container *ngIf="'EMAIL' | translate" data-pw="lost-credentials">
  <div @fadeIn class="nes-flex-col nes-pt-6 nes-mb-8 md:nes-pt-10">
    <nes-link data-pw="link-to-overview-lost-credentials" icon="arrow-left" stand-alone (click)="backToLogin()" relay42>
      {{ 'LOGIN.BACK_TO_LOGIN' | translate }}
    </nes-link>

    <nes-heading class="nes-mb-8" [size]="'6xl'"> {{ 'LOGIN.LOST_CREDENTIALS.HEADER' | translate }} </nes-heading>

    <form class="nes-flex-col nes-w-full md:nes-w-5/12" [formGroup]="emailForm$">
      <ng-container *ngIf="loginErrorTranslation$ | async as message">
        <nes-message-bar
          data-pw="login-error"
          class="nes-mb-2"
          type="error"
          interactive="false"
          border="bottom"
          icon="alert"
        >
          {{ this.loginErrorTranslation$ | async }}
        </nes-message-bar>
      </ng-container>
      <nes-input
        data-pw="email"
        [nesId]="email"
        name="email"
        formControlName="email"
        auto-focus="true"
        max-width="auto"
        type="email"
        [helpText]="'LOGIN.LOST_CREDENTIALS.TITLE' | translate"
        required="true"
        [label]="'LOGIN.AUTH.EMAIL' | translate"
        [error]="this.emailErrorMessage | async"
        (nesOnKeyDown)="this.onKeyDown(emailForm$, $event)"
        (nesOnBlur)="this.checkEmail(emailForm$)"
        [value]="this.emailForm$.get('email').value"
        ngDefaultControl
      >
      </nes-input>
      <div class="nes-flex nes-my-8">
        <nes-button
          data-pw="send-button-lost-credentials"
          width-auto="true"
          variant="primary"
          type="submit"
          [loading]="loading$ | async"
          (click)="resetAccount(emailForm$)"
        >
          <p class="nes-bold nes-text-base">{{ 'LOGIN.SEND' | translate }}</p>
        </nes-button>
      </div>
    </form>

    <mnz-customer-requirements></mnz-customer-requirements>
  </div>
</nes-container>
